import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
export function LocationBlock() {
  return <div className="bg-paper rounded-2xl shadow-soft border border-subtle-gray overflow-hidden flex flex-col lg:flex-row" data-id="element-200">
      {/* Info Side */}
      <div className="p-8 lg:p-12 lg:w-1/2 flex flex-col justify-center" data-id="element-201">
        <h3 className="text-3xl text-ink mb-8" data-id="element-202">Storm Taekwondo</h3>

        <div className="flex flex-col gap-6 mb-8" data-id="element-203">
          <div className="flex items-start gap-4" data-id="element-204">
            <div className="w-12 h-12 bg-off-white rounded-xl flex items-center justify-center shrink-0 text-storm-red" data-id="element-205">
              <MapPin className="w-6 h-6" data-id="element-206" />
            </div>
            <div data-id="element-207">
              <p className="font-bold text-ink text-lg" data-id="element-208">Location</p>
              <p className="text-gray-warm" data-id="element-209">
                24786 Crestview
                <br data-id="element-210" />
                Farmington Hills, MI 48335
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-211">
            <div className="w-12 h-12 bg-off-white rounded-xl flex items-center justify-center shrink-0 text-storm-red" data-id="element-212">
              <Phone className="w-6 h-6" data-id="element-213" />
            </div>
            <div data-id="element-214">
              <p className="font-bold text-ink text-lg" data-id="element-215">Phone</p>
              <a href="tel:517-220-0621" className="text-gray-warm hover:text-storm-red transition-colors" data-id="element-216">
                517-220-0621
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-subtle-gray" data-id="element-217">
          <p className="font-bold text-ink mb-2" data-id="element-218">Serving Nearby Communities:</p>
          <p className="text-gray-warm text-sm leading-relaxed" data-id="element-219">
            Farmington Hills, Novi, Commerce, Walled Lake, Wixom, Livonia,
            Farmington, Waterford, Northville and nearby Southeast Michigan
            areas.
          </p>
        </div>
      </div>

      {/* Map Placeholder Side */}
      <div className="lg:w-1/2 h-80 lg:h-auto bg-subtle-gray relative" data-id="element-220">
        {/* Simple map pattern placeholder */}
        <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: 'radial-gradient(#1F1F23 1px, transparent 1px)',
        backgroundSize: '20px 20px'
      }} data-id="element-221"></div>
        <div className="absolute inset-0 flex items-center justify-center flex-col gap-3 p-6 text-center" data-id="element-222">
          <div className="w-16 h-16 bg-storm-red rounded-full flex items-center justify-center shadow-lg animate-bounce" data-id="element-223">
            <MapPin className="w-8 h-8 text-white" data-id="element-224" />
          </div>
          <div className="bg-white px-4 py-2 rounded-lg shadow-md font-bold text-ink" data-id="element-225">
            Farmington Hills, MI
          </div>
        </div>
      </div>
    </div>;
}